import ResultsKnowledge from './resultsKnowledge.js';
export default ResultsKnowledge;
